import { Waypoints } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/cn';
import { providerChainLine } from '@/lib/rebooking/flight-provider';
import type { FlightProviderAttempt } from '@/lib/rebooking/types';

/**
 * «Proveedor de la aerolínea: no conectado · Duffel: sin ofertas · Atlas: sin ofertas» —
 * the flight providers rebooking's latest search asked for this PNR, in order, and why each
 * did or did not answer (contract `airline-air-ticketing.v1` §3). Renders nothing when there
 * is no chain to tell (a search that asked no provider, an older rebooking).
 */
export function ProviderChainNote({
  attempts,
  className,
  testId = 'provider-chain',
}: {
  attempts: readonly FlightProviderAttempt[] | null | undefined;
  className?: string | undefined;
  testId?: string | undefined;
}) {
  const { t } = useTranslation('rebooking');
  const { t: tNetwork } = useTranslation('network');
  const line = providerChainLine(attempts, t, tNetwork);
  if (!line) return null;
  const title = t('providerChain.title');
  return (
    <p
      className={cn('flex items-start gap-1.5 text-[11px] text-muted-foreground', className)}
      title={`${title}: ${line}`}
      data-testid={testId}
    >
      <Waypoints className="mt-0.5 h-3 w-3 shrink-0" aria-hidden />
      <span className="min-w-0">
        <span className="sr-only">{title}: </span>
        {line}
      </span>
    </p>
  );
}
